import React, { useMemo } from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { datahubInfoSelector } from 'Redux/selectors';
import { getDatahubIsOutdated } from 'Internals/datahub';
import { SubActions } from 'Redux/thunks/subscriptions.thunks';
import { CustomConnectionsThunk } from 'Redux/thunks/customConnectionURL.thunks';

import { SubscriptionAvatar } from '../components/subscription-avatar/SubscriptionAvatar.view';

const SubscriptionAvatarContainer = ({
  connectionUrl,
  customConnectionURL,
  name,
  nowrap,
  subId,
  withLink,
  isDefaultUrl,
  router,
  shouldDisplayRestoreLinkButton,
}) => {
  const dispatch = useDispatch();
  const datahubInfo = useSelector(datahubInfoSelector);
  const isConnected = useSelector((state) => state.subscription.connected);
  const subscriptionId = useSelector((state) => state.subscription.id);
  const defaultConnection = useSelector((state) => state.subscription.defaultConnectionUrl);
  const datahubOutdated = useMemo(() => {
    return getDatahubIsOutdated(datahubInfo);
  }, [datahubInfo]);

  const onRestoreConnectionClick = () => {
    dispatch(SubActions.attemptConnectV2(subscriptionId, defaultConnection)).then(() => {
      dispatch(CustomConnectionsThunk.removeCustomConnection(subscriptionId));
    });
  };

  const tooltipOnLClick = () => {
    router.push(`/subscription/${subId}/settings-subscription/basics`);
  };

  return (
    <SubscriptionAvatar
      connectionUrl={connectionUrl}
      customConnectionURL={customConnectionURL}
      name={name}
      nowrap={nowrap}
      subId={subId}
      withLink={withLink}
      isDefaultUrl={isDefaultUrl}
      shouldDisplayRestoreLinkButton={shouldDisplayRestoreLinkButton}
      datahubOutdated={datahubOutdated}
      isConnected={isConnected}
      defaultConnection={defaultConnection}
      onRestoreConnectionClick={onRestoreConnectionClick}
      tooltipOnLClick={tooltipOnLClick}
    />
  );
};

SubscriptionAvatarContainer.propTypes = {
  connectionUrl: PropTypes.string,
  customConnectionURL: PropTypes.string,
  name: PropTypes.string.isRequired,
  nowrap: PropTypes.bool,
  subId: PropTypes.string.isRequired,
  withLink: PropTypes.bool,
  isDefaultUrl: PropTypes.bool,
  router: PropTypes.shape({}),
  shouldDisplayRestoreLinkButton: PropTypes.bool,
};

SubscriptionAvatarContainer.defaultProps = {
  connectionUrl: '',
  isDefaultUrl: true,
  nowrap: false,
  withLink: false,
  shouldDisplayRestoreLinkButton: false,
};

const Wrapped = withRouter(SubscriptionAvatarContainer);

export { Wrapped as SubscriptionAvatarContainer };
